import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(SplitText);

export default class Scroll {
    constructor() {
        this.split = new SplitText('.js-scrollmovetxt', { type: 'chars' });
        this.hasAnimated = false;
        this.init();
    }

    init() {
        this.initAnimation();
        this.scrollAnimation();
        this.smoothScroll();
    }

    initAnimation() {
        const isChildOfClass = (element, className) => {
            while (element) {
                if (element.classList && element.classList.contains(className)) {
                    return true;
                }
                element = element.parentNode;
            }
            return false;
        };

        // 読み込み時に実行
        this.split.chars.forEach((char) => {
            // charの親が特定のクラスを持っているか確認
            if (!isChildOfClass(char, 'l-pagehead__head')) return;
            this.moveAnimation(char);
        });
    }

    scrollAnimation() {
        const headerLogo = document.querySelector('.l-header__logo');

        ScrollTrigger.create({
            trigger: 'body',
            start: 'top top',
            end: 'bottom 120%',
            onEnter: (self) => {
                document.body.classList.add('-scrolled');
                headerLogo.classList.remove('-show');
                headerLogo.classList.add('-hide');
            },
            onLeaveBack: (self) => {
                document.body.classList.remove('-scrolled');
                headerLogo.classList.remove('-hide');
                headerLogo.classList.add('-show');
            },
            onUpdate: (self) => {
                // スクロール中の間、ボディにクラスを追加
                document.body.classList.add('-scrolling');

                if (!this.hasAnimated) {
                    this.hasAnimated = true;

                    this.split.chars.forEach((char) => {
                        this.moveAnimation(char);
                    });

                    this.reloadGif();
                }

                // スクロールが停止したかどうかをチェックするためのタイマーをリセット
                clearTimeout(this.scrollTimeout);
                this.scrollTimeout = setTimeout(() => {
                    document.body.classList.remove('-scrolling'); // スクロール停止でクラスを削除
                    this.hasAnimated = false;
                }, 100);
            },
            onLeave: (self) => {
                document.body.classList.remove('-scrolled');
                document.body.classList.add('-endscroll');
            },
            onEnterBack: (self) => {
                document.body.classList.remove('-endscroll');
            },
        });
    }

    moveAnimation(elm) {
        gsap.to(elm, {
            // delayをランダムに設定 0.0から0.2のランダムな値
            delay: Math.random() * 0.2 + 0.0,

            keyframes: [
                { duration: 0.1, yPercent: 2.5, ease: 'power2.out' }, // 5%
                { duration: 0.4, yPercent: 5, ease: 'power2.out' }, // 25%
                { duration: 0.1, yPercent: -2.5, ease: 'power2.out' }, // 30%
                { duration: 0.1, yPercent: -3.75, ease: 'power2.out' }, // 35%
                { duration: 0.2, yPercent: 2.5, ease: 'power2.out' }, // 45%
                { duration: 0.1, yPercent: 3.75, ease: 'power2.out' }, // 50%
                { duration: 0.2, yPercent: -1.25, ease: 'power2.out' }, // 60%
                { duration: 0.1, yPercent: -1.75, ease: 'power2.out' }, // 65%
                { duration: 0.2, yPercent: 0, ease: 'power2.out' }, // 75%から100%まで変化なし
            ],
        });
    }

    reloadGif() {
        document.querySelectorAll('.js-gif').forEach((gif) => {
            const currentSrc = gif.getAttribute('src');
            gif.setAttribute('src', '');
            gif.offsetHeight;
            gif.setAttribute('src', currentSrc);
        });
    }

    smoothScroll() {
        const triggers = document.querySelectorAll('.js-smoothscroll');

        triggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = el.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    // `window.pageYOffset` の代わりに `window.scrollY` を使用
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    gsap.to(window, { duration: 1, scrollTo: targetPosition, ease: 'circ.inOut' });
                }
            });
        });
    }
}
